import moment from 'moment'
export default {
  computed: {
    idCombo () {
      const me = this
      if (me.carrito.length < 1) {
        return null
      }
      return me.carrito[0].combo
    },
    /*
    subsidio () {
      const me = this
      let proveedor = me.proveedor
      if (!this.proveedores || !proveedor) {
        return null
      }
      return this.proveedor.subsidio
    },
    */
    subtotalPedido () {
      console.log('subtotalPedido')
      let subtotal = 0
      const me = this
      if (me.carrito.length > 0 && me.precioCombo) {
        subtotal = me.carrito.length * me.precioCombo.precio
      }
      return subtotal
    },
    subtotalSubsidios () {
      const me = this
      let subtotal = 0
      if (me.carrito.length > 0) {
        me.carrito.forEach((itemCarrito) => {
          subtotal += me.getSubsidioDia(itemCarrito.fecha)
        })
      }
      return subtotal
    },
    subtotalGeneral () {
      return this.subtotalPedido - this.subtotalSubsidios
    }
  },
  methods: {
    cantidadPlatosCategoriaDia (dia, idCategoria) {
      const me = this
      let contador = 0
      let diaCarrito = me.carrito.find((itemCarrito) => {
        return itemCarrito.fecha === dia
      })
      if (diaCarrito) {
        diaCarrito.proveedor.forEach((proveedor) => {
          proveedor.platos.forEach((platoCarrito) => {
            if (platoCarrito.plato.categoria._id === idCategoria) {
              contador += platoCarrito.cantidad
            }
          })
        })
      }
      console.log('cantidadPlatosCategoriaDia')
      return contador
    },
    getDiaCarrito (dia) {
      const me = this
      let item = me.carrito.find((itemCarrito) => {
        return itemCarrito.fecha === dia
      })
      return item
    },
    getPlatoProveedorDia (dia, plato) {
      const me = this
      let platoProveedor

      const proveedor = me.getProveedorDia(dia, plato.proveedor)
      if (proveedor) {
        platoProveedor = proveedor.platos.find((platoProveedor) => {
          return platoProveedor.plato._id === plato._id
        })
      }
      return platoProveedor
    },
    getPorcentajeSubsidio (fecha) {
      const me = this
      let porc = 0
      let diaNombre = moment(new Date(fecha)).utc().format('dddd')
      if (me.subsidio) {
        porc = me.subsidio[diaNombre]
      }
      return porc
    },
    getProveedorDia (dia, idProveedor) {
      const me = this
      let proveedorEncontrado
      let diaCarrito = me.getDiaCarrito(dia)
      if (diaCarrito) {
        proveedorEncontrado = diaCarrito.proveedor.find((proveedor) => {
          return proveedor._id === idProveedor
        })
      }
      return proveedorEncontrado
    },
    getSubtotal (fecha) {
      const me = this
      let subtotal = 0
      let montoSubsidiado = me.getSubsidioDia(fecha)
      if (me.precioCombo) {
        subtotal = me.precioCombo.precio - montoSubsidiado
      }
      return subtotal
    },
    getSubsidioDia (fecha) {
      const me = this
      let subsidio = 0
      let porcentajeSubsidio = me.getPorcentajeSubsidio(fecha)
      if (me.precioCombo) {
        subsidio = me.precioCombo.precio * porcentajeSubsidio / 100
      }
      return subsidio
    },
    puedePedirPlato (dia, plato) {
      const me = this
      /* Los admins pueden pedir cualquier cantidad de platos */
      if (me.user.roles[0] === 'admincliente') {
        return true
      }
      /* Los usuarios comunes deben cumplir con las reglas establecidas */
      let puedePedir = false
      let cantidadEnCategoria = me.cantidadPlatosCategoriaDia(dia, plato.categoria._id)
      let reglaCategoria = me.reglas.find((regla) => {
        return regla.categoria._id === plato.categoria._id
      })
      if (reglaCategoria) {
        puedePedir = reglaCategoria.cantidad > cantidadEnCategoria
      }
      return puedePedir
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Carrito.js